import React from 'react';

import { Chip } from '@/shared/components/ui/chip/chip';
import { TUserSourceChipProps } from '@/shared/features/rbac/components/user-source-chip/user-source-chip.types';
import { useEnumLabel } from '@/shared/hooks/use-enum-label/use-enum-label';
import { UserSourceEnum } from '@/shared/types/types.generated';
import { getResellerBranding } from '@/shared/utils/reseller-branding/reseller-branding';

export const UserSourceChip: React.FC<TUserSourceChipProps> = ({
  userSource,
}) => {
  const { getEnumLabel } = useEnumLabel();
  const resellerAbbreviation = getResellerBranding().abbreviation;

  const label =
    userSource === UserSourceEnum.Sda
      ? resellerAbbreviation
      : getEnumLabel(userSource);

  return (
    <Chip
      status={userSource === UserSourceEnum.Sda ? 'grey' : 'purple'}
      label={label}
    />
  );
};
